export const truncateText = (text = "", maxLength = 100) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + "...";
};

export const formatCount = (num = 0) =>
  new Intl.NumberFormat("en-IN").format(num);
